// src/components/team/TeamSection.jsx
import TeamCard from "./TeamCard";

const founders = [
  {
    name: "Nilesh Dhayarkar",
    title: "Change Maker & Co-founder of Impact Together Consultancy Services",
    isFounder: true,
    image: require("../../assets/images/founders/nilesh.jpg"),
    socials: {
      linkedin: "https://linkedin.com/in/nilesh-placeholder",
      twitter: "https://twitter.com/nilesh-placeholder"
    },
    description: `Nilesh brings with him 2 decades of achievements in raising benchmarks at local nonprofit environments, blended with his volunteering work where he has deployed Lean Management for effective and efficient ways of working.

He partners with organizations to improve performance and achieve strategic goals through holistic transformation — integrating people, process, and tools with change management for sustainable impact.`,
  },
  {
    name: "Suresh Pawar",
    title: "Co-founder of Impact Together Consultancy Services",
    isFounder: true,
    image: require("../../assets/images/founders/suresh.jpg"),
    socials: {
      linkedin: "https://linkedin.com/in/suresh-placeholder",
      twitter: "https://twitter.com/suresh-placeholder"
    },
    description: `With over 10 years of experience, Suresh has collaborated with corporate clients on CSR projects, working with organizations like Sandvik, Tata Power, Shapoorji Pallonji, Crompton, Impact Guru Foundation, and WOTR.

He brings extensive CSR expertise to the development sector, having positively impacted over 100,000 lives to date.`,
  },
];



const TeamSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#F4F4FF] via-white to-[#E7F0FF]">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary text-center mb-12">
          Meet the Team Behind the Impact
        </h2>

        {/* Founders */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
          {founders.map((member, idx) => (
            <TeamCard key={idx} {...member} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
